<template>
    <div style="height: 100%">
        <LeftNavBar
            :title="selectedAppInitial"
            :drag="false"
            :hasChild="false"
            :items="sidebarItems"
            @opened="selectEmailType"
            :selectedValue="selectedTab"
        />
    </div>
</template>

<script>
import LeftNavBar from "bh-mod/components/common/LeftNavBar";
export default {
    components: {LeftNavBar },
    name: "menu-left",
    data() {
        return {
            openID: "",
        };
    },
    computed: {
		selectedAppInitial() {
			return this.$store.state.theApp?.media?.initial || "BSB";
		},
        sidebarItems() {
            let items = [
                {
                    label: "Draft",
                    value: "Draft",
                    iconUrl: require("@/assets/sideIcons/draft.svg"),
                },
				{
                    label: "Pending",
                    value: "Pending",
                    iconUrl: require("@/assets/sideIcons/pending.svg"),
                },
				{
                    label: "Processing",
                    value: "Processing",
                    iconUrl: require("@/assets/sideIcons/processing.svg"),
                },
                {
                    label: "Sent",
                    value: "Sent",
					iconUrl: require("@/assets/sideIcons/sent.svg"),
                },
				{
                    label: "Scheduled",
                    value: "Scheduled",
					iconUrl: require("@/assets/sideIcons/scheduled.svg"),
                },
				{
                    label: "Failed",
                    value: "Failed",
					iconUrl: require("@/assets/sideIcons/failed.svg"),
                },
				{
                    label: "Archived",
                    value: "Archived",
					iconUrl: require("@/assets/sideIcons/archived.svg"),
                },
                {
                    divider: true,
                },
                {
                    label: "Settings",
                    value: "Settings",
                    iconUrl: require("@/assets/settings.svg"),
                },
            ];
            return items;
        },
        selectedTab() {
            return this.$store.state.appData.selectedTab;
        },
    },
    methods: {
        selectEmailType(data) {
            if (data.value && this.selectedTab != data.value) {
                if (data.value === "Settings" && this.$route.path !== "/settings") {
                    this.$router.push(`/settings`);
                    return this.$store.commit("SMS_TYPE", data);
                } else if (this.$route.path !== "/") {
                    this.$router.push(`/`);
                    return this.$store.commit("SMS_TYPE", data);
                } else {
                    this.$store.commit("SMS_TYPE", data);
                }
            }
            return;
        }
    },
};
</script>
